/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.rest.route

import com.benasher44.uuid.Uuid

object AssessmentPath {
    const val ROOT = "assessment"
    const val STATE_SEGMENT = "state"
    const val INSIGHT_SEGMENT = "insight"
    const val QUESTION_SEGMENT = "question"

    fun withId(assessmentId: Uuid) = "$ROOT/$assessmentId"

    fun withIdAndState(assessmentId: Uuid) = "${withId(assessmentId)}/$STATE_SEGMENT"

    fun withIdAndInsight(assessmentId: Uuid) = "${withId(assessmentId)}/$INSIGHT_SEGMENT"

    /**
     * Applicable only for a get operation.  May return [HttpStatusCode.NoContent] if the end of the assessment has been
     * reached.
     *
     * @param assessmentId ID of the assessment.
     * @return Path to get the next question in the assessment.
     * @see CustomHeaders.TOTAL_COUNT
     * @see CustomHeaders.CURRENT_INDEX
     */
    fun withIdAndNextQuestion(assessmentId: Uuid) = "${withId(assessmentId)}/$QUESTION_SEGMENT"
}
